import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { COLLABORATIVE_TOKENS_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";
import userService from "@services/user.service";

export function useGetCollaborativeTokens() {
  return useQuery({
    queryKey: [COLLABORATIVE_TOKENS_QUERY_KEY, "TOKENS"],
    queryFn: async () => {
      return userService.getCollaborativeTokens();
    },
    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
